import { render, staticRenderFns } from "./NotLicense.vue?vue&type=template&id=e869779c&scoped=true"
import script from "./NotLicense.vue?vue&type=script&lang=js"
export * from "./NotLicense.vue?vue&type=script&lang=js"
import style0 from "./NotLicense.vue?vue&type=style&index=0&id=e869779c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e869779c",
  null
  
)

export default component.exports